import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReviewsComponentReact } from "./src/ReviewsComponentReact";

//if(!document.getElementById("divProdDetailBelowTheFold")){

//    var divModalContentElement = document.createElement("div");
//    divModalContentElement.id = "divProdDetailBelowTheFold";
                       
//    var aboveTheFoldDiv = document.getElementsByClassName("product-detail__top")[0];
//    aboveTheFoldDiv.parentNode.appendChild(divModalContentElement)

//}

ReactDOM.render(
    <ReviewsComponentReact />,
    document.getElementById("reviewsReact")
);